<template>
    <div v-if="isShow" class="v_all g-flex-align-center g-flex-justify-center">
      <div class="v-no-find">
        <div class="v-no-find-img"></div>
        <p @click="returnMainClick">返回首页</p>
      </div>
    </div>
</template>

<script>
  import NProgress from 'nprogress'
  import componentsRouter from "@/router/componentsRouter";
  import { apiInit } from '@/utils/api.js'
  export default {
     name: 'All',
     data() {
       return {
         isShow: false
       }
     },
    created() {
      //验证
      if (this.$global.token) { //登录了
        if(this.$global.MenuList.length === 0) { //是刷新页面
          NProgress.start()
          this.apiInitHandel()
        }else { //不是刷新
           this.isShow=true
        }
      }else { //没登陆
        this.$router.push('/login')
      }
    },
    methods: {
      // 返回
      returnMainClick() {
        this.$router.replace({ path: '/main' })
      },

      // 获取路由列表
      async apiInitHandel() {
        const { success, data } = await apiInit()
        NProgress.done()
        if(!success) return
        this.$global.ApiList = data.ApiList

        this.$global.adminUser = data.user
        
        let res = this.tree(data.MenuList, 0)

        // 菜单
        this.$global.MenuList = res.MenuList

        // console.log('this.$global.MenuList', this.$global.MenuList)

        // 路由
        let asyncRoutes = [{
          path: '/',
          name: 'layout',
          title: 'layout',
          redirect: res.asyncRoutes[0].path + this.meunPath(res.asyncRoutes[0]),
          component: componentsRouter.Layout,
          children: res.asyncRoutes
        }]

        // console.log('asyncRoutes', asyncRoutes)

        // 添加异步路由
        this.$router.addRoutes(asyncRoutes)         
          this.$router.push({path:this.$route.path,query:this.$route.query}).catch(() => {
              this.isShow=true
          })
      },

      tree(MenuArr, parent_id) {
        //菜单
        let MenuList = []
        //异步路由
        let asyncRoutes = []
        MenuArr.forEach(item => {
           if (item.parent_id == parent_id) { 
             let menu = {
                id: item.id,
                title: item.title,
                icon: item.icon,
                path: item.path
              }

              let router = {
                  path:item.path,
                  component:componentsRouter[item.component],
                  meta:{
                      id:item.id,
                      icon: item.icon,
                      title: item.title,
                  }
              }
              let children
              children = this.tree(MenuArr, item.id)
              if(children.asyncRoutes.length>0) router.children=children.asyncRoutes
              //只push需要显示的菜单
              if(item.is_show==1) {
                  //只push需要显示的菜单
                  if (children.MenuList.length > 0) menu.children = children.MenuList
                  // console.log('isshow', item)
                  MenuList.push(menu)
              }
              asyncRoutes.push(router)
           }
        })
        return {asyncRoutes:asyncRoutes,MenuList:MenuList}
      },

      //寻找默认第一组菜单路径
      meunPath(route) {
          if (route.children) {
              // console.log(route.children)
              return '/' + route.children[0].path + this.meunPath(route.children[0])
          }
          return '';
      },
    },
  }
</script>

<style lang="scss">
.v_all {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  bottom: 0;
  .v-no-find {
    .v-no-find-img {
      width: 600px;
      height: 500px;
      background-image: url('/img/404.png');
      background-size: cover;
      background-repeat: no-repeat;
    }
    p {
      text-align: center;
      font-size: 20px;
      color: #93cdfc; 
      line-height: 40px;
      cursor: pointer;
      text-decoration: underline;
    }
  }
}
</style>